<template>
  <div>
      <div class="ts-flex ts-justify-between">
        <label class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md">{{ $t('wholesale.item') }}</label>
        <AddAutoAfterSearchSerial v-model="model" @calculate="calculate" />
      </div>
      <div class="max-h">
        <table class="ts-w-full">
            <thead>
              <tr>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-4" >{{$t('wholesale.no') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-64" >{{$t('wholesale.product') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16" >{{$t('wholesale.quantity') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16" >{{$t('wholesale.uom') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16">{{$t('wholesale.unitPrice') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-12">{{$t('wholesale.discountType') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-12">{{$t('wholesale.discountRate') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-12">{{$t('wholesale.vatRate') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-10">{{$t('wholesale.isCutom') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-32">{{$t('wholesale.grandTotal') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center ts-w-20" >{{$t('actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in model.product_detail"
                :key="index"
                class="ts-border-b ts-border-gray-300"
              >
                <td class="ts-text-center">{{ index + 1 }}</td>
                <td class="ts-px-2 ts-py-1">
                  <p class="ts-mb-0 ts-font-extrabold ts-text-blue-600">
                    <i class="fab fa-product-hunt"></i> {{ product.product_name_en }}
                  </p>
                  <p class="ts-mb-0">
                    <i class="fas fa-barcode"></i> {{ product.barcode }}
                  </p>
                  <div class="validate" v-if="errors.has('product_detail.' + index + '.serial_list')">
                    {{ errors.first('product_detail.' + index + '.serial_list') }}
                  </div>  
                </td>
                <td>
                  <input
                    v-model.number="product.quantity" 
                    type="number" class="form-control ts-text-center"
                    @input="calculate()"
                  >
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('product_detail.' + index + '.quantity')"
                  >
                    {{ errors.first('product_detail.' + index + '.quantity') }}
                  </div>
                </td>
                <td>
                  <a-select
                    v-model.number="product.uom_id"
                    class="ts-w-full"
                    ref="uom"
                    :class="{
                      'is-invalid': errors.has('product_detail.' + index + '.uom_id'),
                    }"
                    @change="onUomChange(product)"
                  >
                    <a-select-option
                      v-for="(u, index) in getUom(product.product_id)"
                      :key="index"
                      :value="u.uom_id"
                      >{{ u.uom_name_en }}
                    </a-select-option>
                  </a-select>
                </td>
                <td>
                  <input
                    v-model.number="product.unit_price" 
                    type="number" class="form-control ts-text-right"
                    @change="calculate()"
                  >
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('product_detail.' + index + '.unit_price')"
                  >
                    {{ errors.first('product_detail.' + index + '.unit_price') }}
                  </div>
                </td>
                <td>
                  <select
                    class="form-control"
                    ref="discountType"
                    v-model="product.discount_type"
                    @change="calculate(product)"
                  >
                    <option value="$">$</option>
                    <option value="%">%</option>
                  </select>
                </td>
                <td>
                  <input
                    v-model.number="product.discount_rate"
                    type="text"
                    ref="discountRate"
                    class="form-control"
                    @input="calculate()"
                  />
                </td>
                <td>
                    <input
                      v-model.number="product.vat_rate"
                      type="text"
                      ref="vatRate"
                      class="form-control"
                      @input="calculate()"
                    />
                </td>
                <td class="ts-text-center">
                  <input 
                    v-model="product.is_custom"
                    type="checkbox">
                </td>
                <td>
                  <input                 
                    v-model="product.grand_total"
                    type="text"
                    class="ts-border ts-w-full ts-border-gray-300 ts-rounded-sm ts-p-2 ts-text-right ts-outline-none ts-font-extrabold"
                    readonly
                  >
                </td>
                <td class="ts-text-left ts-pl-4 ts-space-x-3">
                  <a
                    href="#"
                    class="ts-text-red-600"
                    @click.prevent="removeRow(product)"
                  >
                    <i class="fa fa-trash"></i>
                  </a>
                  <a href="#" v-if="product.has_serial"
                    @click.prevent="addSerialProduct(product)"
                  >
                    <i class="fas fa-list"></i>
                  </a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="ts-bg-blue-600" colspan="11"></td>
              </tr>
              <tr class="ts-bg-gray-300">
                <td class="ts-px-2 ts-py-1 ts-font-extrabold ts-uppercase" colspan="2"><span>{{$t('wholesale.rowNum') }} : </span>{{ $formatNumber(numRow) }}</td>
                <td class="ts-px-2 ts-py-1 ts-font-extrabold ts-text-red-600 ts-uppercase">
                  <span>{{$t('wholesale.qty') }} : </span> {{ $formatNumber(countQty) }}
                </td>
                <td class="ts-text-right ts-px-2 ts-py-1" colspan="6">
                  <span class="ts-font-extrabold ts-text-red-600 ts-uppercase">{{$t('wholesale.total')}} : </span>
                </td>
                <td class="ts-text-right ts-font-extrabold ts-text-red-600">
                  <input 
                    type="text" 
                    class="ts-w-full ts-p-2 ts-text-right ts-font-extrabold ts-text-red-700 ts-outline-none"
                    :value="totalAmountUSDPrice ? $currencyFormat(totalAmountUSDPrice) : 0"
                    readonly
                  >
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan="3" rowspan="5">
                  <textarea
                    v-model.trim="model.remark" 
                    rows="5" 
                    class="form-control" 
                    :placeholder="$t('wholesale.remark')"
                  ></textarea>
                </td>
                <td colspan="6" class="ts-text-right">
                  <div class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase">
                    <b>{{ $t('wholesale.discount') }}</b>
                  </div>
                </td>
                <td class="ts-text-right">
                  <input 
                    type="number" 
                    class="form-control ts-text-right" 
                    v-model.number="model.discount"
                    @input="calculate"
                  >
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan="6" class="ts-text-right">
                  <div class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase">
                    <b>{{ $t('wholesale.vatRate') }}</b>
                  </div>
                </td>
                <td class="ts-text-right">
                  <input 
                    type="number" class="form-control ts-text-right"
                    v-model.number="model.vat_rate"
                  >
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan="6" class="ts-text-right ">
                  <div class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase">
                    <b>{{ $t('wholesale.vatAmount') }}</b>
                  </div>
                </td>
                <td class="ts-text-right">
                  <input 
                    type="text" class="ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none"
                    :value="model.vat_amount ? $currencyFormat(model.vat_amount) : 0"
                    readonly
                  >
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan="6" class="ts-text-right">
                  <div class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase">
                    <b>{{ $t('wholesale.despositAmount') }}</b>
                  </div>
                </td>
                <td class="ts-text-right">
                  <input 
                    type="text" class="ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none"
                    :value="model.amount_deposit ? $currencyFormat(model.amount_deposit) : 0"
                    readonly
                  >
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan="6" class="ts-text-right">
                  <div class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase">
                    <b>{{ $t('wholesale.grandTotal') }}</b>
                  </div>
                </td>
                <td class="ts-text-right">
                  <input 
                    type="text" class="ts-text-right ts-p-2 ts-w-full ts-text-red-700 ts-font-extrabold ts-border ts-border-gray-400 ts-rounded-sm ts-outline-none"
                    :value="model.grand_total ? $currencyFormat(model.grand_total) : 0"
                    readonly
                  >
                </td>
                <td></td>
              </tr>
            </tfoot>
        </table>
      </div>
      <a-drawer
        v-if="show_serial_input"
        :title="addSerial.product_name_en"
        :width="400"
        :zIndex="1020"
        :visible="show_serial_input"
        :body-style="{ paddingBottom: '80px' }"
        @close="() => show_serial_input = false"
      >
        <AddProductSerialManual v-model="addSerial" @calculate="calculate" />
      </a-drawer>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapGetters } from 'vuex'
import AddProductSerialManual from './add-product-serial-manual.vue'
import AddAutoAfterSearchSerial from './auto-after-search-serial.vue'
export default {
  name: 'itemDetails',
  props: ['value', 'validate'],
  components: {
    AddProductSerialManual,
    AddAutoAfterSearchSerial
  },
  data() {
    return {
      errors: new Errors(),
      show_serial_input: false,
      addSerial: {
        product_name_en: null
      },
      model: {}
    }
  },
  computed: {
    ...mapGetters('wholesale/operation', [
      'getUom',
      'getSalePrice'
    ]),
    numRow() {
      return this.model.product_detail.length
    },
    countQty() {
      return _.sumBy(this.model.product_detail, 'quantity')
    },
    sumUSDPrice() {
      return _.sumBy(this.model.product_detail, 'unit_price')
    },
    totalAmountUSDPrice() {
      return _.sumBy(this.model.product_detail, 'grand_total')
    },
  },
  created() {
    this.model = this.value
  },
  methods: {
    removeRow(row) {
      this.model.product_detail.splice(this.model.product_detail.indexOf(row),1)
      this.calculate()
    },
    onUomChange(row) {
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id,
      })
      this.calculate()
    },
    calculate() {
        this.model.product_detail.forEach((detail) => {
          var amount = _.round(detail.unit_price * detail.quantity, 2)
          if (detail.discount_type == '$') {
            detail.discount_amount = detail.discount_rate
          }
          if (detail.discount_type == '%') {
            detail.discount_amount = (amount * detail.discount_rate) / 100
          }
          detail.total_after_discount = _.round(
            amount - detail.discount_amount,
            2
          )
          detail.vat_rate = detail.vat_rate ? detail.vat_rate : 0
          detail.vat_amount = _.round(
            (detail.total_after_discount * detail.vat_rate) / 100,
            2
          )
          detail.grand_total = _.round(
            detail.total_after_discount + detail.vat_amount,
            2
          )
        })

        this.model.sub_total = _.round(
          _.sumBy(this.model.product_detail, 'grand_total'),
          2
        )
        this.model.discount = this.model.discount ? this.model.discount : 0
        this.model.total_after_discount = _.round(
          this.model.sub_total - this.model.discount,
          2
        )
        this.model.vat_rate = this.model.vat_rate ? this.model.vat_rate : 0
        this.model.vat_amount = _.round(
          this.model.total_after_discount * (this.model.vat_rate / 100),
          2
        )
        this.model.grand_total = _.round(
          (this.model.total_after_discount + this.model.vat_amount) - this.model.amount_deposit,
          2
        )

        this.model.amount_paid = this.model.grand_total
        this.model.amount_due = 0
    },
    addSerialProduct(product){
      this.addSerial = product
      this.show_serial_input = true
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>

<style scoped>
.max-h {
  height: 510px;
  max-height: 520px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  /* border-spacing: 0;  */
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: white;
}
</style>